import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var DEFAULT_SIZE = 2;
var HEADING_SIZE_STYLES = {
  1: "text-4xl font-black text-body tracking-widest uppercase leading-125 mt-md mb-lg " + "tw:text-4xl tw:font-bold tw:text-darkest tw:tracking-normal tw:normal-case tw:leading-160 tw:mt-md tw:mb-lg",
  2: "text-xl font-black text-darkest leading-125 mt-sm mb-md " + "tw:text-3xl tw:font-bold tw:text-darkest tw:leading-150 tw:mt-sm tw:mb-md",
  3: "font-bold text-darkest leading-125 mt-sm mb-md " + "tw:text-2xl tw:font-bold tw:text-darkest tw:leading-160 tw:mt-sm tw:mb-md",
  4: "text-sm font-normal leading-125 text-dark mt-sm mb-md " + "tw:text-xl tw:font-normal tw:text-dark tw:leading-160 tw:mt-sm tw:mb-md",
  5: "text-xs text-secondary font-bold tracking-wider uppercase leading-125 mt-0 mb-md " + "tw:text-lg tw:text-body tw:font-normal tw:tracking-normal tw:normal-case tw:leading-160 tw:mt-0 tw:mb-md"
};
var Heading = function Heading(_a) {
  var _b = _a.size,
    size = _b === void 0 ? DEFAULT_SIZE : _b,
    children = _a.children;
  var sizeClasses = HEADING_SIZE_STYLES[size] || HEADING_SIZE_STYLES[DEFAULT_SIZE];
  var HeadingTag = "h".concat(size);
  return /*#__PURE__*/React.createElement(HeadingTag, {
    className: classNames([sizeClasses, "auto-qa-heading"])
  }, children);
};
Heading.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.number
};

export { Heading };
//# sourceMappingURL=index.es.js.map
